module.exports = __webpack_public_path__ + "img/travel-luggage.9cc40dfa.svg";